<!--
 * @Description: 网站自定义页面详情
 * @Author: git config user.name
 * @Date: 2025-03-21 10:04:49
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-04-16 08:59:10
 * @FilePath: \ngs_platform_manage_admin\src\views\website\pageConfiguration\components\edit.vue
-->
<template>
	<div class="bannerMaintain" style="min-width: 1400px">
		<div class="mt20">
			<el-form
				:model="baseForm"
				ref="baseForm"
				:rules="baseFormRules"
				:show-message="false"
				class="search-form"
				label-position="left"
				label-width="80px"
			>
				<el-row :gutter="40">
					<el-col :span="8">
						<el-form-item label="页面名称" prop="pageName">
							<el-input size="small" v-model="baseForm.pageName" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="应用项目" prop="applySys">
							<el-select v-model="baseForm.applySys" size="small">
								<el-option v-for="(item, index) in yyxm" :key="index" :label="item.sname" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="40" class="mt20">
					<el-col :span="8">
						<el-form-item label="页面用途" prop="pageUse">
							<el-input size="small" v-model="baseForm.pageUse" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="页面入口" prop="pageEntry">
							<el-input size="small" v-model="baseForm.pageEntry" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt20">
					<el-form-item label="" label-width="0px" prop="pageContent">
						<wang-editor v-model="baseForm.pageContent" ref="wangEditor" :height="300"></wang-editor>
					</el-form-item>
				</el-row>
			</el-form>
		</div>

		<div class="center">
			<el-button type="primary" @click="SaveSettings(1)">保存</el-button>
		</div>
	</div>
</template>
<script>
import { saveOrEditDefinePage } from 'api/modules/pageConfiguration'
import { mapActions } from 'vuex'

export default {
	props: {
		yyxm: {
			// 主数组, 应用项目
			type: Array,
			default: () => {
				return []
			}
		},
		detailData: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			baseForm: {
				id: '',
				pageName: '', //页面名称
				applySys: '', //应用项目
				pageUse: '', //页面用途
				pageEntry: '', //页面入口
				pageContent: '' //内容
			},
			baseFormRules: {
				pageName: [{ required: true }],
				pageEntry: [{ required: true }],
				applySys: [{ required: true }]
			},
			parentObject: {} //父级数据
		}
	},
	created() {
		if (this.$route.query.type == 'edit') {
			this.baseForm.id = this.detailData.id
			this.baseForm.pageName = this.detailData.pageName
			this.baseForm.applySys = this.detailData.applySys
			this.baseForm.pageUse = this.detailData.pageUse
			this.baseForm.pageEntry = this.detailData.pageEntry
			this.baseForm.pageContent = this.detailData.pageContent
		}
	},
	methods: {
		...mapActions('app', ['setIsBack']),
		//保存
		SaveSettings() {
			let envType = process.env.NODE_ENV == 'production' ? 1 : 0
			this.$refs.baseForm.validate((valid) => {
				if (valid) {
					let params = this.baseForm
					params.testOrProd = envType
					console.log(process.env.NODE_ENV)
					console.log(envType)
					saveOrEditDefinePage(this.baseForm).then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('提交成功！')
							setTimeout(() => {
								this.baseForm = {
									id: '',
									pageName: '',
									applySys: '',
									pageUse: '',
									pageEntry: '',
									pageContent: ''
								}
							}, 1000)
							// 设置返回状态
							this.setIsBack(true)
							this.$router.replace({
								path: '/redirect' + this.$route.path
							})
						}
					})
				} else {
					this.$message.warning('请填写必填项')
				}
			})
		}
	}
}
</script>
<style scoped>
.center {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}
</style>
